import {
  FETCH_LIBRARY_CARDS_SUCCESS,
  CREATE_LIBRARY_CARD_SUCCESS,
  UPDATE_LIBRARY_CARD_SUCCESS,
  DELETE_LIBRARY_CARD_SUCCESS,
  PRESIGNED_URL_SUCCESS,
  UPLOAD_FILE_SUCCESS,
  FETCH_METADATA_SUCCESS,
  LIST_CARDS_SUCCESS,
  FETCH_CARD_DETAILS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_SUCCESS,
  GET_LIBRARY_CARD_TAGS_FAILURE,
  LIST_ENTITY_CARDS_REQUEST,
  LIST_ENTITY_CARDS_SUCCESS,
  LIST_ENTITY_CARDS_FAILURE,
  SET_SELECTED_SEARCH_SESSION,
  FETCH_LG_COLLECTION_REQUEST,
  FETCH_LG_COLLECTION_SUCCESS,
  FETCH_LG_COLLECTION_FAILURE,
  CLEAR_LG_COLLECTION_DATA,
} from "../actions/libraryCardActions";

const initialState = {
  libraryCards: [], // Array of library cards
  presignedUrls: [], // Array of presigned URLs
  fileUploadResponse: null, // Response for uploaded files
  metadata: null, // Metadata for a library card
  cardDetails: null, // Detailed information for a specific library card
  listCards: [], // List of library cards for a tenant/entity type (legacy)
  // New structure for multiple entity types
  entityLists: {
    AGENTDASHBOARD: [],
    LGSEARCHCRITERIAAPOLLO: [],
    AGENTCONFIG: [],
    N8NWORKFLOW: [],
  },
  loading: {
    AGENTDASHBOARD: false,
    LGSEARCHCRITERIAAPOLLO: false,
    AGENTCONFIG: false,
    N8NWORKFLOW: false,
  },
  // LG Collection data for the selected search session
  lgCollectionData: {
    LGSEARCHCRITERIAAPOLLO: null,
    LGAPOLLOMGR: null,
    LGENRICHMENTRESULT: null,
    LGLEADSFOUND: null,
    LGRESPONSERESULT: null,
    LGSCORINGRESULT: null,
    LGVALIDATIONRESULT: null,
  },
  lgCollectionLoading: {
    LGSEARCHCRITERIAAPOLLO: false,
    LGAPOLLOMGR: false,
    LGENRICHMENTRESULT: false,
    LGLEADSFOUND: false,
    LGRESPONSERESULT: false,
    LGSCORINGRESULT: false,
    LGVALIDATIONRESULT: false,
  },
  selectedSearchSession: null, // Currently selected search session ID
};

const libraryCardReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIBRARY_CARDS_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - FETCH_LIBRARY_CARDS_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        libraryCards: action.payload,
      };

    case CREATE_LIBRARY_CARD_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - CREATE_LIBRARY_CARD_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        libraryCards: [...state.libraryCards, action.payload], // Add the new card to the list
      };

    case UPDATE_LIBRARY_CARD_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - UPDATE_LIBRARY_CARD_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        libraryCards: state.libraryCards.map((card) =>
          card.entityId === action.payload.entityId ? action.payload : card
        ), // Update the existing card
      };

    case DELETE_LIBRARY_CARD_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - DELETE_LIBRARY_CARD_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        libraryCards: state.libraryCards.filter(
          (card) => card.entityId !== action.payload.entityId
        ), // Remove the deleted card
      };

    case PRESIGNED_URL_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - PRESIGNED_URL_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        presignedUrls: action.payload, // Update the state with the presigned URLs
      };

    case UPLOAD_FILE_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - UPLOAD_FILE_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        fileUploadResponse: action.payload, // Update the state with the file upload response
      };

    case FETCH_METADATA_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - FETCH_METADATA_SUCCESS - payload:`,
      //   action.payload
      // );
      return {
        ...state,
        metadata: action.payload, // Update the state with the fetched metadata
      };

    case LIST_CARDS_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - LIST_CARDS_SUCCESS - payload:${JSON.stringify(
      //     action.payload
      //   )}`
      // );
      const result = {
        ...state,
        listCards: action.payload.pageNames, // Update the state with the list of library cards
      };
      console.log(
        `PMM - SF - libraryCardReducer.js - LIST_CARDS_SUCCESS - result is: ${JSON.stringify(
          result
        )}`
      );
      return result;

    case FETCH_CARD_DETAILS_SUCCESS:
      console.log(
        `PMM - SF - libraryCardReducer - FETCH_CARD_DETAILS_SUCCESS - payload:`,
        action.payload
      );
      console.log(
        `PMM - SF - libraryCardReducer - FETCH_CARD_DETAILS_SUCCESS - payload type:`,
        typeof action.payload
      );
      console.log(
        `PMM - SF - libraryCardReducer - FETCH_CARD_DETAILS_SUCCESS - payload is null/undefined:`,
        action.payload == null
      );
      return {
        ...state,
        cardDetails: action.payload,
      };

    case GET_LIBRARY_CARD_TAGS_SUCCESS:
      // console.log(
      //   `PMM - SF - reducer - GET_LIBRARY_CARD_TAGS_SUCCESS - payload.tags:`,
      //   action.payload.tags
      // );
      return {
        ...state,
        libraryCardTags: action.payload.tags, // Update the state with the presigned URLs
      };

    case GET_LIBRARY_CARD_TAGS_FAILURE:
      console.log(
        `PMM - SF - reducer - GET_LIBRARY_CARD_TAGS_FAILURE - payload:`,
        action.payload
      );
      return {
        ...state,
        loading: false,
        error: action.payload.error, // Store error message for tags in the state
      };

    case LIST_ENTITY_CARDS_REQUEST:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.entityType]: true,
        },
      };

    case LIST_ENTITY_CARDS_SUCCESS:
      console.log(
        `LIST_ENTITY_CARDS_SUCCESS - entityType: ${action.payload.entityType}, data:`,
        action.payload.data
      );
      // Handle the case where the API returns { pageNames: [...] } instead of direct array
      const entityData =
        action.payload.data.pageNames || action.payload.data || [];
      return {
        ...state,
        entityLists: {
          ...state.entityLists,
          [action.payload.entityType]: entityData,
        },
        loading: {
          ...state.loading,
          [action.payload.entityType]: false,
        },
      };

    case LIST_ENTITY_CARDS_FAILURE:
      return {
        ...state,
        loading: {
          ...state.loading,
          [action.payload.entityType]: false,
        },
        error: action.payload.error,
      };

    // LG Collection cases
    case SET_SELECTED_SEARCH_SESSION:
      return {
        ...state,
        selectedSearchSession: action.payload,
      };

    case FETCH_LG_COLLECTION_REQUEST:
      return {
        ...state,
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: true,
        },
      };

    case FETCH_LG_COLLECTION_SUCCESS:
      return {
        ...state,
        lgCollectionData: {
          ...state.lgCollectionData,
          [action.payload.collectionType]: action.payload.data,
        },
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: false,
        },
      };

    case FETCH_LG_COLLECTION_FAILURE:
      return {
        ...state,
        lgCollectionLoading: {
          ...state.lgCollectionLoading,
          [action.payload.collectionType]: false,
        },
        error: action.payload.error,
      };

    case CLEAR_LG_COLLECTION_DATA:
      return {
        ...state,
        lgCollectionData: {
          LGSEARCHCRITERIAAPOLLO: null,
          LGAPOLLOMGR: null,
          LGENRICHMENTRESULT: null,
          LGLEADSFOUND: null,
          LGRESPONSERESULT: null,
          LGSCORINGRESULT: null,
          LGVALIDATIONRESULT: null,
        },
        lgCollectionLoading: {
          LGSEARCHCRITERIAAPOLLO: false,
          LGAPOLLOMGR: false,
          LGENRICHMENTRESULT: false,
          LGLEADSFOUND: false,
          LGRESPONSERESULT: false,
          LGSCORINGRESULT: false,
          LGVALIDATIONRESULT: false,
        },
        selectedSearchSession: null,
      };

    default:
      return state;
  }
};

export default libraryCardReducer;
